// extracted by mini-css-extract-plugin
export default {"container":"ChoiceQuestionStarted_container__DP5Az","questionText":"ChoiceQuestionStarted_questionText__mpZDF","noResponsesText":"ChoiceQuestionStarted_noResponsesText__jEUMt"};